<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

<div *ngIf="!isLoading" class="table-responsive p-l-20 p-r-20">
  <div (click)="create()" class="btn btn-primary float-end">Create</div>

  <table class="table align-middle tableStyle">
    <thead>
    <tr>
      <th class="">Inbound E-mail</th>
      <th class="">E-mail Address</th>
      <th class="">Email Alias</th>
      <th class="">Priority</th>
      <th class=""></th>

    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of filterData() ">
      <td><span class="divLink" (click)="edit(row.Id)">{{row.Name}}</span></td>
      <td>{{row.SDeskEmailAlias}}&#64;parse.{{instanceParams.EnvironmentUrl}}</td>
      <td>{{row.ClientEmailAlias}}</td>
      <td *ngIf="row.EmailPriority !== 0">{{row?.EmailPriority}}</td>
      <td *ngIf="row.EmailPriority == 0"></td>
      <td>
        <i class="far fa-trash-alt float-end m-r-20 divLink" (click)="delete(row.Id)"></i>
        <i class="fas fa-cog float-end m-r-20 divLink" (click)="edit(row.Id)"></i>
      </td>
    </tr>
    </tbody>
  </table>
</div>
